import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header1 from "../layout/header/header1";

import { withTranslation } from "react-i18next";

class Contact2 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: "",
			email: "",
			contact_number: "",
			gender: "",
			age: "",
			school: "",
			content: "",
		};
		this.itemRefs = [];
	}
	componentDidMount() {

	}

	handleSubmit = async (event) => {
	};

	handleChange = (event) => {
		const { name, value } = event.target;
		this.setState({ [name]: value });
	};

	render() {
		const { t } = this.props;
		return (
			<>
				<Header1 />

				<div className="page-content">
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("Contact_LinkHome")}</Link>
								</li>
								<li>{t("Contact_LinkContact")}</li>
							</ul>
						</div>
					</div>
					<div className="container">
						<div className="content-block">
							<div className="page-banner contact-page">
								<div className="container-fuild">
									<div className="row m-lr0">
										<div className="col-lg-6 col-md-6 section-sp2 p-lr30">
											<div className="heading-bx left p-r15">
												<h2 className="title-head">{t("Contact_Information")}</h2>
											</div>
											<div className="row placeani">
												<div className="col-lg-3 pull-right">
													<div className="label">
														<h3>{t("Contact_Phone_Label")}</h3>
													</div>
												</div>
												<div className="col-lg-6 pull-right">
													<div className="value">
														<div style={{ fontSize: 28 + "px" }}>
															{t("Contact_Phone_Value")}
														</div>
													</div>
												</div>
											</div>
											<div className="row placeani">
												<div className="col-lg-3 pull-right">
													<div className="label">
														<h3>{t("Contact_Website_Label")}</h3>
													</div>
												</div>
												<div className="col-lg-6 pull-right">
													<div className="value">
														<div style={{ fontSize: 28 + "px" }}>
															<a href={`https://${t("Contact_Website_Value")}`} style={{ textDecoration: "underline" }} target="_blank" rel="noopener noreferrer">
																{t("Contact_Website_Value")}
															</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default withTranslation()(Contact2);
